import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Button, Divider, Stack, TextField, Typography } from "@mui/material"

import { useForm } from '../../../../hooks';
import { PrincipalLayouts } from '../../../../layouts';
import { Field } from '../../miProfile/Field';
import { DateInput } from '../../DateInput';
import { createFund } from '../../../helpers/fund';

export const AddFunds = () => {

    const navigate = useNavigate();
    const [isWaiting, setIsWaiting] = useState(false);
    const { t } = useTranslation('global');
    const [formValues, handleInputChange, reset] = useForm({ name: '', registrationDate: '', percentagePaid: '' });

    const { name, registrationDate, percentagePaid } = formValues;

    const handleConfirm = async (e) => {
        e.preventDefault();
        setIsWaiting(true)
        createFund(formValues, t('funds.succesMsg'), t('funds.errorMsg'), t('funds.errorNameDup'), navigate)
        setIsWaiting(false)
        reset()
    }

    const handleCancel = () => {
        reset();
        navigate('/positions')
    }

    return (
        <PrincipalLayouts>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography color='primary' variant='h5'>{t('funds.addFunds')}</Typography>
            </Stack>
            <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

            <form onSubmit={handleConfirm}>
                <Stack minHeight='calc(100vh - 290px)' gap={2}>

                    <Stack>
                        <Field translation='funds' name={name} title='name' handleInputChange={handleInputChange} required={true} />
                    </Stack>

                    <Stack>
                        <DateInput name={registrationDate} title='registrationDate' handleInputChange={handleInputChange} required={true} />
                    </Stack>

                    <Stack >
                        <Typography variant='overline' color='secondary'>{t('number.percentagePaid')}</Typography>
                        <TextField
                            fullWidth
                            name='percentagePaid'
                            size="small"
                            variant="outlined"
                            value={percentagePaid}
                            onChange={handleInputChange}
                            required={true}
                            type='number'
                            InputProps={{ inputProps: { min: 0, max: 100, step: 'any' } }}
                        />
                    </Stack>

                </Stack>

                <Stack direction='row' justifyContent='end' gap={2} marginTop={3}>
                    <Button sx={{ width: '140px' }} color='secondary' onClick={handleCancel} variant="outlined">{t('myprofile.cancelButton')}</Button>
                    <Button disabled={isWaiting} sx={{ width: '140px' }} type='submit' variant="contained">{t('myprofile.confirmButton')}</Button>
                </Stack>
            </form>

        </PrincipalLayouts>
    )
}